module.exports = __webpack_public_path__ + "img/hamburger.e2b0a142.svg";